import { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

import { useDispatch } from "react-redux";
import { refreshToken3 } from "../../actions";

const TokenRefresher = withRouter(
  injectIntl(() => {
    const [timerId, setTimerId] = useState(null);

    const dispatch = useDispatch();

    useEffect(() => {
      return () => {
        clearInterval(timerId);
      };
    }, []);

    useEffect(() => {
      if (!timerId) {
        const id = setInterval(() => {
          dispatch(refreshToken3({}));
        }, 1000 * 59);

        setTimerId(id);
      }

      return () => {};
    }, [timerId]);

    return null;
  })
);

export default TokenRefresher;
